import { PropsWithChildren } from 'react';

export enum ModalMods {
  Xs = 'xs',
}

export type ModalProps = PropsWithChildren<{
  onClose(): void;
  active?: boolean;
  mods?: ModalMods[];
}>;
